module.exports = __webpack_public_path__ + "static/media/background.d05b8566.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/background.jpg
// module id = 993
// module chunks = 0